import React from 'react';
import PropTypes from 'prop-types';
import CardActionArea from '@mui/material/CardActionArea';

import MuiCard from '@mui/material/Card';
import { styled } from '@mui/system';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';

const StyledCardActionArea = styled(CardActionArea)({
  '&.Mui-disabled': {
    cursor: 'pointer'
  }
});

const StyledCard = styled(MuiCard, {
  shouldForwardProp: muiPropForwarding('ownState')
})(({ theme, ownState }) => {
  // NOTE: This ownState pattern is a pattern that I've adapted
  // from how the MUI team internally passes custom styles through
  // their styled components
  const ownMuiCardRootStyles = ownState?.card?.(theme) ?? {};

  return {
    '&.MuiCard-root': {
      backgroundColor: 'inherit',
      ...ownMuiCardRootStyles
    }
  };
});

function Card({
  children,
  disabled,
  handleClick,
  role,
  dataTestId,
  ownState,
  ...rest
}) {
  return (
    <StyledCard ownState={ownState}>
      <StyledCardActionArea
        onClick={handleClick}
        disabled={disabled}
        role={role}
        data-testid={dataTestId}
      >
        {children}
      </StyledCardActionArea>
    </StyledCard>
  );
}

Card.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  handleClick: PropTypes.func,
  role: PropTypes.string,
  dataTestId: PropTypes.string,
  ownState: PropTypes.object
};

export default Card;
